import axios from "axios";
import { deleteSubSampleQuery, mutateSampleQuery, mutateSubSampleQuery, deleteSampleQuery,
  mutateAreaQuery, createUpdateGroupQuery, mutationContactQuery, mutationSiteQuery, uploadFieldSampleData, alertMessages, deleteContactQuery
} from "src/constants";
import { errorResponse } from "src/store/common";
import { configHandleFuelModels } from "./getFuelSampleCalls";

const siteStatusCheck = (status: string)=>{
  if(status.toLowerCase().includes('inactive')){
    return 0
  }
  else if(status.toLowerCase().includes('active')){
    return 1
  }
  else{
    return null
  }
};


export const createUpdateSample = async(token: string|null, params: any, setAddSampleCalled:any, fromUpdate: boolean, addAlert: any) => {
  try {
      let data = JSON.stringify({
        query: mutateSampleQuery,
        variables:{
          site_id: params.siteId,
          fuel_sample_id: params.fuel_sample_id,
          fuel_type: params.sampleType,
          category: params.sampleCategory,
          sub_category: params.sampleSubCategory,
          method: params.sampleMethod,
          sample_status: params.sample_status,
          sample_datetime: params.sampleDate,
          sample_average_value: params.sample_average_value
        }
      });
      let config = configHandleFuelModels(data, null);
      return(
      new Promise(function(resolve,reject){
      axios(config)
        .then(async function (response: any) {
          if(response.data.errors){
            if(!fromUpdate){
              setAddSampleCalled(true);
            }
            return reject(new Error(response.data.errors[0].message))
          }
          else{
            if(!fromUpdate){
              setAddSampleCalled(true);
            }
            return resolve(response)

          }
        })
        .catch(function (error: any) {
          if(!fromUpdate){
            setAddSampleCalled(true);
          }
          return reject(new Error(error.data.errors[0]))
        });
      })
      )
    }
    catch (error:any) {
      if(!fromUpdate){
        setAddSampleCalled(true);
      }
      if (error?.message?.includes('duplicate')) {
        errorResponse(error, addAlert, error.message);
      }
      else {
        errorResponse(error, addAlert, alertMessages.fieldSampleSave);
      }

    }
};

export const checkWeightsAndValue = (tar_weight: number, dry_weight: number, wet_weight: number, value: number) =>{
  if((!tar_weight || !dry_weight || !wet_weight) && !value){
    return null
  }
  else{
    return Number(value)
  }
}
export const createUpdateSubSample = async(token: string|null, addAlert:any, params: any) => {
  try {
    let data = JSON.stringify({
      query: mutateSubSampleQuery,
      variables:{
        sub_sample:params.subsamples, 
        sample_id: params.sampleId
      }
    });
    let config = configHandleFuelModels(data, null);
    return(
      new Promise(function(resolve,reject){
          axios(config)
          .then(async function (response: any) {
            if(response.data.errors){
              if(response.data.errors[0].message){
                errorResponse(response.data.errors[0].message, addAlert, response.data.errors[0].message, false);
                return reject(new Error(response.data.errors[0].message));
              }
            } else {
              const subSampleUpdatedOrCreated= response.data.data.createFuelSubSamples;
              return resolve(subSampleUpdatedOrCreated)
            }
          })
          .catch(function (error: any) {
              console.log('error', error);
              return reject(new Error(error))
          });
      })
    )
  }
  catch (error) {
    console.log('error', error);  
    errorResponse(error, addAlert,alertMessages.fieldSampleSave);

  }
};

export const deleteSubSample = async(token: string|null, addAlert: any, sub_id: number) => {
  try {
    let data = JSON.stringify({
      query: deleteSubSampleQuery,
      variables:{
        fuel_sub_sample_id:sub_id
      }
    });
    let config = configHandleFuelModels(data, null);
    return(
      new Promise(function(resolve,reject){
          axios(config)
          .then(async function (response: any) {
            if(response.data.errors){
              if(response.data.errors[0].message){
                return reject(new Error(response.data.errors[0].message))
              }
            }
            else{
              const deletedSubSample = response.data.data.deleteFuelSubSample;
              return resolve(deletedSubSample)
            }
          })
          .catch(function (error: any) {
              console.log('error', error);
              return reject(new Error(error))
          });
      })
    )
  }
  catch (error) {
    console.log('error', error);
    errorResponse(error, addAlert,alertMessages.fieldSampleDelete);

  }
};

export const deleteSample = async(token: string|null, addAlert: any, sample_id: number) => {
  try {
    let data = JSON.stringify({
      query: deleteSampleQuery,
      variables:{
        sample_id:sample_id
      }
    });
    let config = configHandleFuelModels(data, null);
    return(
      new Promise(function(resolve,reject){
          axios(config)
          .then(async function (response: any) {
              if(response.data.errors){
                if(response.data.errors[0].message){
                  errorResponse(response.data.errors[0].message, addAlert);
                  return reject(new Error(response.data.errors[0].message))
                }
                else{
                  return reject(new Error(response.data))
                }
              }
              else{
                const deletedSubSample = response.data.data.deleteFuelSample;
                return resolve(deletedSubSample)
              }
          })
          .catch(function (error: any) {
            console.log('error', error)
              return reject(new Error(error))
          });
      })
    )
  }
  catch (error) {
    console.log('error', error);
    errorResponse(error, addAlert,alertMessages.fieldSampleDelete);

  }
}

export const createUpdateGroup = async(token: string|null, addAlert: any, params: any) => {
  try {
    let data = JSON.stringify({
      query: createUpdateGroupQuery,
      variables: {
        groupId: params.groupId ? params.groupId : null,
        groupName: (params.groupName).trim(),
        areaId:params.areaId,
        status: params.status,
        groupContacts: params.groupContacts,
        deleteGroupContacts: params.deleteGroupContacts
      }
    });
    let config = configHandleFuelModels(data, null);
    return (
      new Promise(function(resolve, reject) {
        axios(config)
          .then(async function (response: any) {

            if(response.data.errors && response.data.errors.length > 0){
              return reject(new Error(response.data.errors))
            }
            else{
              if(params.groupId){
                //edit was successful
                errorResponse('', addAlert, `The changes to the group, ${response.data.data.createUpdateGroup.groupName}, were saved.`, true);
              }
              else{
                errorResponse('', addAlert,  `The new group, ${response.data.data.createUpdateGroup.groupName}, was saved.`, true);
              }
              return resolve(response)
            }
          })
          .catch(function (error: any) {
            console.log('error', error);
            return reject(new Error(error))

          });
        })
      )
  } catch (error) {
    console.log('error', error);
    errorResponse(error, addAlert,alertMessages.saveGroup);

  }
}
export const createUpdateArea = async(token: string|null, addAlert: any, params: any) => {
  try {
    let data = JSON.stringify({
      query: mutateAreaQuery,
      variables:{
          areaId: (params.areaId).trim(),
          areaName: (params.areaName).trim(),
          areaContacts: params.areaContacts,
          deleteAreaContacts: params.deleteAreaContacts,
        }
    });
    let config = configHandleFuelModels(data, null);
    return(
      new Promise(function(resolve,reject){
          axios(config)
          .then(async function (response: any) {
            if(response.data.errors && response.data.errors.length > 0){
              return reject(new Error(response.data.errors));
            }else{
              const areaCreated= response.data.data.createUpdateArea;
              if(params.editArea){
                //edit was successful
                errorResponse('', addAlert, `The changes to the area, ${areaCreated.areaName}, were saved.`, true);
              }
              else{
                errorResponse('', addAlert,  `The new area, ${areaCreated.areaName}, was saved.`, true);
              }
              return resolve(areaCreated)
            }
          })
          .catch(function (error: any) {
              console.log('error', error);
              return reject(new Error(error))
          });
      })
    )
  }
  catch (error) {
    console.log('error', error);
    errorResponse(error, addAlert,alertMessages.saveArea);

  }
};

export const createUpdateContact = async(token: string|null, addAlert: any, contactRequest: any) => {
  try {
    let data = JSON.stringify({
      query: mutationContactQuery,
      variables:{
          contactId: contactRequest.id,
          name: contactRequest.contactName? (contactRequest.contactName).trim(): null,
          phone: contactRequest.phone,
          extension: contactRequest.extension,
          email: contactRequest.email,
          location: contactRequest.location,
          title: contactRequest.position? (contactRequest.position).trim():null,
        }
    });
    let config = configHandleFuelModels(data, null);
    return(
      new Promise(function(resolve,reject){
          axios(config)
          .then(async function (response: any) {
            if(response.data.errors && response.data.errors.length > 0){
              return reject(new Error(response.data.errors));
            }
            else{
              const contactCreated = response.data.data.createUpdateContacts;
              if(contactRequest.id){
                //edit was successful
                errorResponse('', addAlert, `The changes to the contact, ${contactCreated.contactName}, were saved.`, true);
              }
              else{
                errorResponse('', addAlert,  `The new contact, ${contactCreated.contactName}, was saved.`, true);
              }
              return resolve(contactCreated)
            }
          })
          .catch(function (error: any) {
              console.log('error', error);
              return reject(new Error(error))
          });
      })
    )
  }
  catch (error) {
    console.log('error', error);
    errorResponse(error, addAlert, alertMessages.saveContacts);

  }
};

export const createUpdateSite =async(token: string|null, addAlert: any, siteRequestVar: any) => {
  try {
    let data = JSON.stringify({
      query: mutationSiteQuery,
      variables:{
        siteId: siteRequestVar?.siteId,
        siteStartDate: siteRequestVar?.siteStartDate,
        active: siteStatusCheck(siteRequestVar?.siteStatus),
        siteName: (siteRequestVar.siteName).trim(),
        groupId: siteRequestVar?.groupId,
        stateId: siteRequestVar?.stateId,
        jurisdiction: (siteRequestVar.jurisdiction? siteRequestVar.jurisdiction:'').trim(),
        latitude: siteRequestVar?.latitude,
        longitude: siteRequestVar?.longitude,
        elevation: siteRequestVar?.elevation,
        remarks: siteRequestVar?.remarks
      }
    });
    let config = configHandleFuelModels(data, null);
    return(
      new Promise(function(resolve,reject){
          axios(config)
          .then(async function (response: any) {
            if(response.data.errors && response.data.errors.length > 0){
              return reject(new Error(response.data.errors[0].message));
            }
            const siteCreated = response.data.data.createUpdateSites;

            if(siteCreated){
              if(siteRequestVar.siteId){
                //edit was successful
                errorResponse('', siteRequestVar.addAlert, `Site "${siteCreated.siteName}" changes were successfully saved to group ${siteCreated.groupName}`, true);
              }
              else{
                errorResponse('',siteRequestVar.addAlert,  `Site "${siteCreated.siteName}" successfully added to group ${siteCreated.groupName}.`, true);
              }
              return resolve(siteCreated)
            }
          })
          .catch(function (error: any) {
              console.log('error', error);
              return reject(new Error(error))
          });
      })
    )
  }
  catch (error:any) {
    console.log('error', error);
    if(error.data?.errors[0].message?.includes('no timezone found')){
      errorResponse(error, addAlert, alertMessages.latlong);
    } else if(error.data?.errors[0].message?.includes('site already exist')) {
      errorResponse(error, addAlert, alertMessages.saveUniqueSite);
    } else {
      errorResponse(error, addAlert, alertMessages.saveSite);
    }
  }
};

export const uploadFieldSampleMutation = async(token: string|null, addAlert: any, request:any) => {
  try {
    let data = JSON.stringify({
      query: uploadFieldSampleData,
      variables: {
        fileName: request.fileName,
        fileType: request.fileType,
        fileFormat: request.fileFormat,
        fileContents: request.fileContents,
        fileSize: request.fileSize
      }
    });
    let config = configHandleFuelModels(data, null);
    return (
      new Promise(function(resolve, reject) {
        axios(config)
          .then(async function(response: any) {
            if(response.data.errors) {
              errorResponse('', request.addAlert, response.data.errors[0]?.message, false);
            }
            else {
              const responseData = response.data.data.uploadFieldSampleData;
              if(responseData.status === '200 OK') {
                errorResponse('', request.addAlert, 'File has been uploaded to FEMS and is processing. For status updates please see table below.', true);
                return resolve(responseData);
              } else {
                errorResponse('', request.addAlert, responseData.status, false);
              }
            }
            return reject(new Error(response.data.errors[0]?.message));
          })
          .catch(function(error:any) {
            console.log('error', error);
            return reject(new Error(error));
          });
      })
    );
  } catch (error) {
    console.log('error', error);
    errorResponse(error, addAlert, alertMessages.getFiles);
  }
};

export const deleteContact = async(token: string|null, addAlert: any, contactId : number) => {
  try {
    let data = JSON.stringify({
      query: deleteContactQuery,
      variables:{
          contactId: contactId,
        }
    });
    let config = configHandleFuelModels(data, null);
    return(
      new Promise(function(resolve,reject){
          axios(config)
          .then(async function (response: any) {
            if(response.data.errors && response.data.errors.length > 0){
              return reject(new Error(response.data.errors));
            }
            else{
              const contactDeleted: boolean = response.data.deleteContact;
              return resolve(contactDeleted)
            }
          })
          .catch(function (error: any) {
              console.log('error', error);
              return reject(new Error(error))
          });
      })
    )
  }
  catch (error) {
    console.log('error', error);
    errorResponse(error, addAlert, alertMessages.siteSampleData);

  }
};